import { useState, useEffect, useLayoutEffect } from 'react';

// router
import { useSearchParams } from "react-router-dom";

// services
import { getAppToken } from "../services/auth";
import { getHeadquarters, getBrands } from "../services/qrheadquarters";

// components
import QRCode from 'qrcode.react';

// styles
import {
  Box,
  Button,
  Grid,
  Select,
  Typography,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";


function QrHeadquarters({ isMobile, setCurrentBrand }) {
// Hooks para token
const [searchParams] = useSearchParams();
const [brandId, setBrandId] = useState("");
const [userId, setUserId] = useState("");
const [existingToken, setExistingToken] = useState(false);

// Hooks loading
const [isLoading, setIsLoading] = useState(true);

// Hooks del componente
const [value, setValue] = useState();
const [valueBrand, setValueBrand] = useState();
const [valueHeadquarter, setValueHeadquarters] = useState();
const [dataBrands, setDataBrands] = useState([]);
const [dataHeadquarters, setDataHeadquarters] = useState([]);
const [errorCollection, setErrorCollection] = useState([]);
const [linkData, setLinkData] = useState(null);

// Peticion de token

// Obtener data de url variables u y b
useLayoutEffect(() => {
  setUserId(searchParams.get("u"));
  setBrandId(searchParams.get("b"));
  setCurrentBrand(searchParams.get("b"));
  localStorage.setItem("current_brand", searchParams.get("b"));
}, []);

// Consumir endpoint para obtener token cada 1000 milisegundos
useEffect(() => {
  if (userId && brandId && !existingToken) {
    const interval = setInterval(() => {
      getAuthToken(interval);
    }, 1000);
  }
}, [userId, brandId]);

const url = 'https://documents.mybt.com.co'; // Esta constante debe ser cambiada por variables de entorno segun el ambiente


// Endpoint para obtener token
const getAuthToken = async (interval) => {
  try {
    const response = await getAppToken();
    if (response.data) {
      localStorage.setItem("access_token_bt", response.data.access_token);
      localStorage.setItem("refresh_token_bt", response.data.access_token);
      clearInterval(interval);
      setExistingToken(true);
    }
  } catch (err) {
    console.log(err);
  }
};

// Consumo de endpoints para obtener sedes(brand)
useEffect(() => {
  if (existingToken) {
    fetchBrands();
    fetchHeadquarters();
  }
}, [existingToken]);

const fetchBrands= async () => {
  setIsLoading(true);
  try {
    const response = await getBrands(1);
    if (response.data.status === "success") {
      setDataBrands(response.data.data);
    } else {
      setErrorCollection(response.data.message);
      setBrandId(false);
      setUserId(false);
      setLinkData(response.data.data);
    }
  } catch (err) {
    console.log(err);
  } finally {
    setIsLoading(false);
  }
};

const fetchHeadquarters= async () => {
  setIsLoading(true);
  try {
    const response = await getHeadquarters();
    // console.log(response);
    if (response.data.status === "success") {
      setDataHeadquarters(response.data.data);
    } else {
      setErrorCollection(response.data.message);
      setBrandId(false);
      setUserId(false);
      setLinkData(response.data.data);
    }
  } catch (err) {
    console.log(err);
  } finally {
    setIsLoading(false);
  }
};

// Cambio del hook value para obtener url por selects (Brands y Headquarters)
useEffect(() => {
  console.log(valueBrand);
  console.log(valueHeadquarter);
  if (valueBrand && valueHeadquarter){
    setValue(`${url}/createLead?b=${valueBrand}&v=${valueHeadquarter}`);
  }
}, [valueBrand, valueHeadquarter]);

const download = function() {
  const link = document.createElement("a");
  link.download = `${value}.png`;
  link.href = document.getElementById("image").toDataURL();
  link.click();
};

return (
  <Grid item xs={12}>
    <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignContent: 'center',
          p: 1,
          m: 1,
          height: '100vh',
        }}>
      <Box display={"flex"} alignContent={'center'} justifyContent={"center"} mb={2} width={'100%'}>
        <InputLabel>Qr por sedes</InputLabel>
      </Box>
      <Box display={"flex"} alignContent={'center'} justifyContent={"center"} mb={2} width={'100%'}>
        <TextField
          label="Qr escrito"
          type="text"
          onChange={(e) => setValue(e.target.value)}
          placeholder="Escribe el texto que deseas en QR"
        />
      </Box>
      <Box display={"flex"} alignContent={'center'} justifyContent={"center"} mb={2} width={'100%'}>
        <InputLabel>Qr por sedes (Necesita token para usar esta opción)</InputLabel>
      </Box>
      <Box display={"flex"} alignContent={'center'} justifyContent={"center"} mb={2} width={'100%'}>
        {dataBrands && 
          (
            <Select
              label="Selecciona una marca"
              defaultValue={0}
              onChange={(e) => setValueBrand(e.target.value)}
            >
              <MenuItem key={`key0`} value={0}>Seleccione una marca</MenuItem>
              {dataBrands.map((item) => (
                <MenuItem key={`key${item.id}`} value={item.id}>{item.name}</MenuItem>
              ))}
            </Select>
          )
        }
        {dataHeadquarters && 
          (
            <Select
              label="Selecciona una sede"
              defaultValue={0}
              onChange={(e) => setValueHeadquarters(e.target.value)}
            >
              <MenuItem key={`key0`} value={0}>Seleccione una sede</MenuItem>
              {dataHeadquarters.map((item) => (
                <MenuItem key={`key${item.id}`} value={item.id}>{item.brand_id}_{item.name}</MenuItem>
              ))}
            </Select>
          )
        }
      </Box>
      <Box display={"flex"} alignContent={'center'} justifyContent={"center"} mb={2} width={'100%'}>
        {value && 
          (
            <QRCode
              id="image"
              value={value}
            />
          )
        }
      </Box>
      <Box display={"flex"} alignContent={'center'} justifyContent={"center"} mb={2} width={'100%'}>
        <Button type="button" color="success" onClick={download}>
          Download QR
        </Button>
      </Box>
    </Box>
	</Grid>
);
}

export default QrHeadquarters;
